import React from 'react';
import { DeviceType } from '../enum/EnumRepository';
import { useDeviceStore } from '../store/deviceStore';

interface MobileBanWrapperProps {
  children: React.ReactNode;
}

const MobileBanWrapper: React.FC<MobileBanWrapperProps> = ({ children }) => {
  const { deviceType } = useDeviceStore();

  if (deviceType === DeviceType.MOBILE) {
    return null;
  }

  return <>{children}</>;
}

export default MobileBanWrapper;